import { useAuthentication } from '@ravago/shared/authentication';

import { useQuery } from '@tanstack/react-query';

import { CustomerUtils } from '../customer.utils';

interface UseCurrentCustomerParams {
  enabled?: boolean;
}

export const useCurrentCustomer = ({ enabled = true }: UseCurrentCustomerParams = {}) => {
  const { accessToken } = useAuthentication();

  const {
    data: customer,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: ['currentCustomer'],
    queryFn: () => CustomerUtils.getCurrentCustomer(),
    enabled: enabled && !!accessToken
  });

  return {
    customer,
    isLoading,
    error,
    refetch
  };
};
